const RelationDataList: anm.RelationItem[] = [
    {
        name: 'make-video',
        preview: 'https://assets.animatron.com/images/landing/success_stories/success_story_logo_981.png',
        description: 'wv.ss1.website',
        title: 'wv.ss1.website',
        url: 'https://www.981media.com/'
    },
    {
        name: 'mari1',
        preview: 'https://assets.animatron.com/images/landing/success_stories/mari1_preview.jpg',
        alt: 'wv.ss2.mari1.title',
        description: 'wv.ss.free-workshop',
        title: 'wv.ss2.mari1.title',
        url: 'wave/videos-for-social-media-mari-smith'
    },
    {
        name: 'fb-cover',
        preview: 'https://assets.animatron.com/images/landing/success_stories/fb-cover_preview.png',
        description: 'wv.ss.read-more',
        title: 'wv.ss2.fb-cover.title',
        url: 'https://www.animatron.com/blog/how-to-make-a-facebook-cover-video-in-5-easy-steps/'
    },
    {
        name: 'edit-social-video-5-steps',
        preview: 'https://assets.animatron.com/images/landing/success_stories/981_edit_videos.jpg',
        description: 'wv.ss.edit-social-video-5-steps',
        title: 'wv.ss2.edit-social-video-5-steps',
        url: 'https://www.animatron.com/blog/edit-videos-for-social-media-in-5-easy-steps/'
    },
    {
        name: 'make-video-never-done-before',
        preview: 'https://assets.animatron.com/images/landing/success_stories/981-diy-video.jpg',
        description: 'wv.ss.edit-social-video-5-steps',
        title: 'wv.ss2.diy-video',
        url: 'https://www.animatron.com/blog/how-to-make-a-video-if-youve-never-done-it-before-a-step-by-step-guide/'
    },
    {
        name: 'what-is-video-marketing',
        preview: 'https://assets.animatron.com/images/landing/success_stories/what-is-video-marketing.jpg',
        description: 'wv.ss.edit-social-video-5-steps',
        title: 'wv.homestars.what-is-video-marketing',
        url: 'https://www.animatron.com/blog/what-is-video-marketing-and-why-does-your-company-need-it/'
    },
    {
        name: 'sm-cheat-sheet',
        preview: 'https://assets.animatron.com/images/landing/success_stories/cheat_sheet.jpg',
        description: 'wv.ss.edit-social-video-5-steps',
        title: 'wv.homestars.sm-cheat-sheet',
        url: 'https://www.animatron.com/blog/social-media-cheat-sheet-for-video-ad-specs/'
    }
];

class RelationList implements ng.IComponentController {
    list: any;

    constructor() {
        this.list = this.list.map((relationName: string) => {
            return RelationDataList.filter((relationItem: anm.RelationItem) => relationItem.name === relationName)[0];
        });
    }
}

angular.module('animatronApp.relationList', []).component('relationList', {
    bindings: {
        list: '<'
    },
    controller: RelationList,
    templateUrl: require('landing-template/components/relation-list.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/landing-template/components/RelationList.ts